import { IEmpresaCommandEdit } from "../interfaces/IEmpresa";
import { Ifilter, IfilterEmpresa } from "../interfaces/IFilter";
import { fetchAdministracion } from "./http-common";

let urlEmpresa = 'Empresa';

const all = (filter: Ifilter | IfilterEmpresa) => {
    return fetchAdministracion.get(`${urlEmpresa}/ListarPorCustomer`, { params: filter });
}
const comboTransportista = (filter: Ifilter) => {
    return fetchAdministracion.get(`${urlEmpresa}/ComboTransportistaPorCustomer`, { params: filter });
}

const allVuelo = (filter: Ifilter) => {
    return fetchAdministracion.get(`${urlEmpresa}/Vuelo`, { params: filter });
}

const allTitularMMG = (filter: Ifilter, controller = new AbortController()) => {
    return fetchAdministracion.get(`${urlEmpresa}/TitularMMG`, {
        params: filter,
        signal: controller.signal
    });
}

const actualizaEmpresa = (data: IEmpresaCommandEdit) => {
    return fetchAdministracion.put(`${urlEmpresa}`, data);
}

const allCombo = (filter: Ifilter) => {
    return fetchAdministracion.get(`${urlEmpresa}/ComboListarPorCustomer`, { params: filter });
}

const EmpresaService = {
    all,
    allVuelo,
    allTitularMMG,
    actualizaEmpresa,
    allCombo,
    comboTransportista
}

export default EmpresaService;